import { Request } from 'api';
import { AxiosResponse } from 'axios';

interface TrackEvent {
    uuid: string;
    individual_uuid: string;
    event_type: string;
    result_value: number;
    result_unit: string;
    meet_name?: string;
    meet_date?: string;
    meet_location?: string;
    school?: string;
    year?: string;
    notes?: string;
    created_at: string;
    individual?: any;
}

interface GetTrackEventsFilters {
    'filter.individual'?: string;
    'filter.group'?: string;
    'filter.event_type'?: string;
    'filter.date_from'?: string;
    'filter.date_to'?: string;
    limit?: number;
    page?: number;
}

type ReturnType = Promise<AxiosResponse<{ data: TrackEvent[]; links: any; meta: any }>>;

const getTrackEvents = (filters: GetTrackEventsFilters = {}): ReturnType => {
    return Request.get('/workouts/track-events', {
        params: filters,
    });
};

export default getTrackEvents;
